import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import EventsList from '@/Pages/Events/EventsList';

function Events() {
  return (
    <Routes>
      <Route path="/" element={<EventsList />} />

      <Route path="*" element={<Navigate to="/not-found" replace />} />
    </Routes>
  );
}

export default Events;
